export default __webpack_public_path__ + "static/media/up-arrow1.10d106e5.svg";